<template>
  <div>
    <div class="container">
      <div class="row mt-3" v-if="gameSlug === 'tafl'">
        <div class="col-md-10 col-lg-10 col-xl-10 mb-3">
          <h1 class="text-primary">Learn Hnefatafl</h1>
          <div class="card mb-4" v-if="false">
            <div class="card-body lead bg-dark text-light">
              This page is a work in progress and does not contain all the rules.
            </div>
          </div>
          <p class="lead">There are different rule sets when playing Hnefatafl. <br>Litafl uses <strong class="font-weight-bold">Copenhagen rules</strong> at the moment.</p>

          <h2 class="mt-4">Gameplay</h2>
          <div class="row">
            <div class="col-4">
              <h4 class="mt-4">Typical starting position</h4>
              <img class="img-fluid" src="/img/board.png" alt="Board">
              <p class="mb-5"><em>a 11x11 Hnefatafl board. 5 bases in total, 1 in center, and 4 in corners.</em></p>
            </div>
            <div class="col-8">
              <h4 class="mt-4">1) How to move</h4>
              <p>All pieces move any number of vacant squares along a row or a column, like a rook in chess. Only the <em>king of defenders</em>&nbsp;<img style="width: 20px;" src="/img/tafl_king.png" alt="King"> can move to a base (the one in center or the ones in the corners).</p>
              <h4 class="mt-4">2) Objectives</h4>
              <p>Attackers play first. Unlike chess, teams try to achieve different things.</p>

              <div class="media mb-3">
                <img style="width: 30px;" src="/img/tafl_attacker.png" alt="Attacker">
                <div class="media-body ml-2">
                  <h5 class="mt-0">Attackers</h5>
                  <p>Their objective is to capture the <em>king of defenders</em>&nbsp;<img style="width: 20px;" src="/img/tafl_king.png" alt="King"></p>
                  <h6>How to capture</h6>
                  <ul>
                    <li>Surround the king from all 4 sides</li>
                  </ul>
                </div>
              </div>
              <div class="media">
                <img style="width: 30px;" src="/img/tafl_defender.png" alt="Defender">
                <div class="media-body ml-2">
                  <h5 class="mt-0">Defenders</h5>
                  <p>Their objective is to get the king to safety before attackers capture it.</p>
                  <h6>How to get the king to safety</h6>
                  <ul>
                    <li>Get king to a corner square</li>
                    <!-- <li>Get king to an edge and build a fort</li> -->
                  </ul>
                </div>
              </div>
              <h4 class="mt-4">3) Capturing pieces</h4>
              <p>To capture a piece, you should sandwich it between two of your pieces.</p>

              <div class="row">
                <div class="col-6">
                  <p><strong>Capturing multiple pieces is possible</strong></p>
                  <img class="img-fluid" style="width: 336px;" src="/img/capture3.png" alt="">
                  <p class="mb-5"><em>White plays to green square and captures 3 pieces.</em></p>
                </div>
                <div class="col-6">
                  <p><strong>Base squares can be used in capturing</strong></p>
                  <img class="img-fluid" style="width: 336px;" src="/img/capture3.png" alt="">
                  <p class="mb-5"><em>Both teams can use bases when capturing.</em></p>
                </div>
                <div class="col-6">
                  <p><strong>You can move a piece between two enemy pieces</strong></p>
                  <img class="img-fluid" style="width: 336px;" src="/img/capture3.png" alt="">
                  <p class="mb-5"><em>White plays to green square and captures 3 pieces.</em></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'learn',
  props: ['gameSlug'],
};
</script>
